import gql from 'graphql-tag'
import { User } from '~/graphql/fragments/user.js'

export const UPDATE_SCHOOL_PROFILE = gql`
  mutation schoolUpdateProfile($id: Int!, $school: ModifySchoolInput!) {
    schoolUpdateProfile(id: $id, school: $school) {
      id
      name
      staffSize
      agesTo
      agesFrom
      website
      address
      population
      countryCode
      centerCode
      schoolProfile {
        email
        phone
      }
    }
  }
`

export const BULK_UPDATE_REPORTER_OF_STAFF = gql`
  mutation academySchoolUpdateReportingBulk($listStaffId: [Int], $managerId: Int, $schoolId: Int!) {
    academySchoolUpdateReportingBulk(listStaffId: $listStaffId, managerId: $managerId, schoolId: $schoolId)
  }
`

export const ADD_SCHOOL_STAFFS = gql`
  mutation academySchoolAddStaffs($schoolId: Int!, $inputs: [PersonalProfileInput!]) {
    academySchoolAddStaffs(schoolId: $schoolId, inputs: $inputs) {
      id
      name
      email
      designation
      dateJoin
      qualificationLevels
      yearOfExp
      agesFrom
      agesTo
      media {
        id
        url
        fileName
      }
    }
  }
`
export const UPDATE_PROFILE_SCHOOL_STAFFS = gql`
  mutation academySchoolUpdateStaffProfile($personalProfileId: Int!, $profile: PersonalProfileInput!) {
    academySchoolUpdateStaffProfile(personalProfileId: $personalProfileId, profile: $profile) {
      id
      userId
      name
      email
      designation
      dateJoin
      qualificationLevels
      yearOfExp
      agesFrom
      agesTo
      title
      employeeId
      nric
      organisationTitleId
      manager {
        id
        userId
        name
        media {
          url
        }
      }
      appraisalAssigns {
        id
        insertedAt
        updatedAt
        startDate
        endDate
        status
        appraisal {
          type
          id
          name
          standard
        }
      }
      roles {
        id
        startDate
        endDate
        role {
          id
          name
          permissions
        }
      }
      media {
        id
        url
        fileName
      }
    }
  }
`
export const REMOVE_SCHOOL_STAFFS = gql`
  mutation academySchoolRemoveStaffs($schoolId: Int!, $staffIds: [Int!]) {
    academySchoolRemoveStaffs(schoolId: $schoolId, staffIds: $staffIds)
  }
`

export const ADD_STAFF_CONFIG = gql`
  mutation academyStaffConfigAdd($input: StaffConfigAddInput!) {
    academyStaffConfigAdd(input: $input) {
      schoolId
      school {
        id
      }
      workingHours
    }
  }
`

export const UPDATE_STAFF_CONFIG = gql`
  mutation academyStaffConfigUpdate($input: StaffConfigUpdateInput!) {
    academyStaffConfigUpdate(input: $input) {
      schoolId
      school {
        id
      }
      workingHours
    }
  }
`
export const UPDATE_STAFF_ROLE = gql`
  mutation updateUserRole($schoolId: Int!, $module: Module, $role: AccountRole!, $userIds: [Int!]!, $startDate: Date!) {
    updateUserRole(schoolId: $schoolId, module: $module, role: $role, userIds: $userIds, startDate: $startDate) {
      user {
        ...User
      }
      startDate
      endDate
      name
    }
  }
  ${User}
`

export const REMOVE_USER_ROLE = gql`
  mutation removeUserRole($module: Module!, $role: AccountRole, $schoolId: Int!, $userIds: [Int!]!) {
    removeUserRole(module: $module, role: $role, schoolId: $schoolId, userIds: $userIds)
  }
`

export const UPDATE_STAFF_STATUS = gql`
  mutation userUpdateStatus($status: UserStatus!, $userId: Int!) {
    userUpdateStatus(status: $status, userId: $userId) {
      errors {
        message
      }
    }
  }
`
